function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from '../ProgressiveImage';
import { Wrapper, TitleAvatar, Icon, Avatar } from './styles';
import { BASE_SIZE } from './constants';
export var AvatarIcon = function AvatarIcon(_ref) {
  var size = _ref.size,
      src = _ref.src,
      letter = _ref.letter,
      rest = _objectWithoutProperties(_ref, ["size", "src", "letter"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(TitleAvatar, {
    size: size
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    src: src,
    placeholder: "https://purecars-signal.imgix.net/_blank.png"
  }, function (src, loading) {
    return /*#__PURE__*/React.createElement(Icon, {
      src: src,
      alt: loading ? 'loading...' : letter
    });
  }), /*#__PURE__*/React.createElement(Avatar, {
    size: size
  }, letter)));
};
AvatarIcon.propTypes = {
  size: PropTypes.number,
  src: PropTypes.string.isRequired,
  letter: PropTypes.string.isRequired
};
AvatarIcon.defaultProps = {
  size: BASE_SIZE
};
export default AvatarIcon;